module.exports = __webpack_public_path__ + "media/application/images/ui/silver-member-107db6848a81ec1cd144d6f3b0384ea6.png";